module.exports = __webpack_public_path__ + "static/media/truck.e5b8654f.svg";